import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const SloObservationLazyLoadedStates = new LazyLoadedStatesManager<{ 
    base: LazyLoadedStates, 
    sloDashboard: LazyLoadedStates, 
    sloDashboardView: LazyLoadedStates,
    sloDetails: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.user-summary.slo',
        url: '/slo',
        abstract: true
    },
    sloDashboard: {
        name: 'authenticated.user-summary.slo.dashboard',
        url: '/dashboard/:userId/:observationId',
        abstract: true,
    },
    sloDashboardView: {
        name: 'authenticated.user-summary.slo.dashboard.view',
        url: '/view'
    },
    sloDetails: {
        name: 'authenticated.user-summary.slo.details',
        url: '/details/:userId/:observationId?tabIndex',
        params: {
            tabIndex: {
                raw: true,
                type: 'int',
                value: 1
            }
        }
    },
},
() => import('src/app/observations/slo/slo.module')
    .then((result: { SloModule: any }) => result.SloModule));
